import React, {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'

interface AIAssistantContextType {
  clearConversation: () => void
  conversationId: string | null
  hasConversation: boolean
  setConversationId: (id: string | null) => void
  setHasConversation: (value: boolean) => void
}

const AIAssistantContext = createContext<AIAssistantContextType | undefined>(
  undefined
)

interface AIAssistantProviderProps {
  children: ReactNode
}

export const AIAssistantProvider: FC<AIAssistantProviderProps> = ({
  children,
}) => {
  const [hasConversation, setHasConversation] = useState(false)
  const [conversationId, setConversationId] = useState<string | null>(null)

  const clearConversation = useCallback(() => {
    setConversationId(null)
    setHasConversation(false)
  }, [])

  return (
    <AIAssistantContext.Provider
      value={{
        clearConversation,
        conversationId,
        hasConversation,
        setConversationId,
        setHasConversation,
      }}
    >
      {children}
    </AIAssistantContext.Provider>
  )
}

export const useAIAssistant = (): AIAssistantContextType => {
  const context = useContext(AIAssistantContext)
  if (!context) {
    throw new Error('useAIAssistant must be used within AIAssistantProvider')
  }
  return context
}
